import React from 'react'
import { ToastContainer, toast, cssTransition, ToastPosition } from 'react-toastify'

import styles from './globalCommunicationWrapper.module.scss'
import { Toast, TOAST_TYPES } from './globalCommunicationWrapper.types'
import CrossIcon from './icons/cross-light.inline.svg'
import ErrorIcon from './icons/errorIcon.inline.svg'
import InfoIcon from './icons/infoIcon.inline.svg'
import SuccessIcon from './icons/successIcon.inline.svg'
import WarningIcon from './icons/warningIcon.inline.svg'
import 'react-toastify/dist/ReactToastify.css'

const TOAST_TYPES_VS_ICONS = {
  [TOAST_TYPES.error]: ErrorIcon,
  [TOAST_TYPES.warning]: WarningIcon,
  [TOAST_TYPES.success]: SuccessIcon,
  [TOAST_TYPES.info]: InfoIcon,
}

const faceInFadeOut = cssTransition({
  enter: `${styles.animation} ${styles.animation__fadeIn}`,
  exit: `${styles.animation} ${styles.animation__fadeOut}`,
})

const ToastElement = ({ toastDetails, closeToast }: { toastDetails: Toast; closeToast?: () => void }) => {
  const Icon = TOAST_TYPES_VS_ICONS[toastDetails.type]
  return (
    <div className={`${styles.toast}`}>
      <div className={styles.iconWrapper}>
        <Icon className={styles.icon} />
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.title}>{toastDetails.title}</div>
        {toastDetails.description && <div className={styles.description}>{toastDetails.description}</div>}
      </div>
      <div className={styles.closeWrapper}>
        <CrossIcon onClick={closeToast} className={styles.closeIcon} />
      </div>
    </div>
  )
}

export const addGlobalMessage = (toastDetails: Toast) => {
  toast(({ closeToast }) => <ToastElement toastDetails={toastDetails} closeToast={closeToast} />, {
    autoClose: toastDetails.duration ?? 5000,
    position: toastDetails.position,
  })
}

export const addCustomGlobalMessage = (CustomComponent: React.FC<any>, toastDetails: Toast) => {
  toast(({ closeToast }) => <CustomComponent toastDetails={toastDetails} closeToast={closeToast} />, {
    autoClose: toastDetails.duration ?? 5000,
    position: toastDetails.position,
  })
}

interface GlobalCommunicationWrapperProps {
  toastContainerPosition?: ToastPosition
  containerId: string
}

const GlobalCommunicationWrapper = ({
  toastContainerPosition = 'top-right',
  containerId = 'globalConatiner',
}: GlobalCommunicationWrapperProps) => {
  return (
    <ToastContainer
      containerId={containerId}
      transition={faceInFadeOut}
      position={toastContainerPosition}
      className={styles.toastContainer}
      hideProgressBar
      closeButton={false}
      toastClassName={styles.toastWrapper}
      bodyClassName={styles.toastBody}
    />
  )
}

export default GlobalCommunicationWrapper
